export enum IAvailableLocaleTypes {
  EN = 'en',
  TH = 'th',
}

export const DefaultLocale = IAvailableLocaleTypes.EN;
